var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLearningResources({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 65 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22.5,
    cy: 22.5,
    r: 22.5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.52539 13.6082V11.5L11.5254 12.1667L23 15.9915V35.8698V38L21 37.2667L9.52539 33.0593V13.6082ZM11.5254 31.6624V14.2749L21 17.433V35.1365L11.5254 31.6624ZM36.4745 13.6082V11.5L34.4745 12.1667L23 15.9915V35.8698V38L25 37.2667L36.4745 33.0593V13.6082ZM25 35.1365L34.4745 31.6624V14.2749L25 17.433V35.1365ZM18.9999 20L12.9999 18L13.3162 17.0513L19.3162 19.0513L18.9999 20ZM32.9999 18L26.9999 20L26.6837 19.0513L32.6837 17.0513L32.9999 18ZM18.9999 26L12.9999 24L13.3162 23.0513L19.3162 25.0513L18.9999 26ZM32.9999 24L26.9999 26L26.6837 25.0513L32.6837 23.0513L32.9999 24ZM18.9999 32L12.9999 30L13.3162 29.0513L19.3162 31.0513L18.9999 32ZM32.9999 30L26.9999 32L26.6837 31.0513L32.6837 29.0513L32.9999 30Z",
    fill: "#FF6E00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLearningResources);
export default __webpack_public_path__ + "static/media/learning-resources.e9a7ff957eca8e1832fb424a7f9e25ce.svg";
export { ForwardRef as ReactComponent };